"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpAdminLeftMenu = void 0;
const tmpls_1 = require("./tmpls");
const ClassesTags_1 = require("../ClassesTags");
const App_1 = require("../App");
class CmpAdminLeftMenu extends tmpls_1.CmpAdminLeftMenuBase {
    constructor() {
        var _a, _b;
        super();
        this.ctrls.btnArticles.onclick = () => {
            this.ctrls.btnArticles.flipClass(ClassesTags_1.ClassesTags.Active);
            this.ctrls.blockArticles.showSet(this.ctrls.btnArticles.hasClass(ClassesTags_1.ClassesTags.Active));
        };
        this.ctrls.btnLogout.onclick = () => App_1.App.Auth.dropAuthAsync();
        this.ctrls.lUsername.text = (_b = (_a = App_1.App.Auth.user) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
    }
}
exports.CmpAdminLeftMenu = CmpAdminLeftMenu;
//# sourceMappingURL=CmpAdminLeftMenu.js.map